export default __webpack_public_path__ + "static/media/tunesie.84433762.svg";